export enum L1Name {
    Requirement = 'Requirement',
    Feature = 'Feature',
    Workstream = 'Workstream',
    ChangeAnalysis = 'Change Analysis',
    ChaRM = 'ChaRM',
    FixPackage = 'Fix Package'
}
